export default {
    url: 'brand-story',
    include: ['jp'],
}